<template>
  <VView class="contest-instructions-3" back-button-to="/menu" :header="$t('contestInstructions.header')">
    <VText>w grze napotkasz również przeszkody, które należy ominąć, aby nie stracić jednego z trzech serduszek. jeżeli stracisz wszystkie trzy to gra się zakończy!</VText>

    <VBlock max-width="548px">
      <img src="@/assets/instructions-3.png" />
    </VBlock>

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton to="/contest/game">Zacznij grę!</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'ContestInstructions3',
};
</script>

<style lang="scss" scoped>
.contest-instructions-2 {}
</style>
